import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const trialBannerDismissedAtom = atomWithStorage<boolean>(
  "ai_trial_banner_dismissed",
  false,
  createJSONStorage(() => localStorage),
  { getOnInit: true },
);
